import React, { Component } from "react";

import Footer from "../Layout/Footer";
import BoxConfigurationPagination from "../Layout/BoxConfigurationPagination";
import CreateOrderBatchModal from "./CreateOrderBatchModal";

import OAuthService from '../Auth/OAuthService';

import {
    Row, Col,
    Container,
    Button,
    // Table
    Alert
} from 'reactstrap';
// import BoxOrder from "./BoxOrder";
// import BoxJob from "./BoxJob";

// import { humanize } from '../../box-helpers'
// import AssignmentIcon from '@material-ui/icons/Assignment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel, faCartArrowDown } from '@fortawesome/free-solid-svg-icons';
import { faImagePolaroid, faSquareSlidersVertical } from '@fortawesome/pro-solid-svg-icons';

class MyBoxConfigurations extends Component {
    constructor(props){
        super(props);
        this.os = new OAuthService();
        this.state = {
            openBatchModal: false,
            configurations: []
        };
    }

    componentDidMount = () => {

    }

    handleConfigurationsLoaded = (configurations) => {
        this.setState({ configurations });
    }

    toggleBatchModal = () => {
        this.setState(prevState => ({ openBatchModal: !prevState.openBatchModal }));
    }

    render() {
        return (
            <div key="my-box-configurations">
                <Container fluid>
                    <Row>
                        <Col>
                            <div>
                                <Row>
                                    <Col className="col" md={{ size:8, offset:2}}>
                                        <Alert color="secondary" className="text-left">
                                            <h4 className="text-center"><FontAwesomeIcon icon={faSquareSlidersVertical} /> <strong>Box Job Templates</strong></h4>
                                            <p className="text-center mb-0">
                                                Save your enclosure configurations with drill and UV print settings.
                                                Order multiple templates at once with the <strong>Create Order</strong> button.
                                            </p>
                                        </Alert>
                                    </Col>
                                </Row>

                                 <Row className="mb-2">
                                    <Col className="col" md={4}>
                                        <Alert color="primary" className="mb-1">
                                            <h5 className="demarginify">
                                                Step 1: Design
                                            </h5>
                                            <div>
                                                <ol className="mb-0 pl-3">
                                                    <li>Create <a href="/my-drill-templates"><FontAwesomeIcon icon={faHotel} /> Drill Templates</a> for your enclosures.</li>
                                                    <li>Upload <a href="/my-uv-print-templates"><FontAwesomeIcon icon={faImagePolaroid} /> UV Design Templates</a> for custom graphics.</li>
                                                    <li>Click <strong>"+ New Box Job Template"</strong> to combine your designs into a reusable template.</li>
                                                </ol>
                                            </div>
                                        </Alert>
                                    </Col>
                                    <Col className="col" md={4}>
                                        <Alert color="success" className="mb-1">
                                            <h5 className="demarginify">
                                                Step 2: Order
                                            </h5>
                                            <div>
                                                <ol className="mb-0 pl-3">
                                                    <li>Click the green <strong>"Create Order"</strong> button below.</li>
                                                    <li>Select up to 10 templates and set quantities.</li>
                                                    <li>Review all products, then click <strong>"Reserve Box Jobs and Create Order"</strong>.</li>
                                                    <li>Complete your purchase on <a href="https://www.taydaelectronics.com" target="_blank" rel="noopener noreferrer">TaydaElectronics.com</a>.</li>
                                                </ol>
                                            </div>
                                        </Alert>
                                    </Col>
                                    <Col className="col" md={4}>
                                        <Alert color="warning" className="mb-1">
                                            <h5 className="demarginify">
                                                Step 3: Track
                                            </h5>
                                            <div>
                                                <ol className="mb-0 pl-3">
                                                    <li>Your order will appear in your <a href="/dashboard">Dashboard</a> within 15-20 minutes.</li>
                                                    <li>Box Jobs will be automatically created from your Reserved templates when your order is received.</li>
                                                    <li>Track production status and any messages on your Dashboard.</li>
                                                </ol>
                                            </div>
                                        </Alert>
                                    </Col>
                                </Row>

                                <div style={{ clear: 'both'}}></div>
                                <div className="text-center mt-1">
                                    <Button color="success" size="lg" onClick={this.toggleBatchModal}>
                                        <FontAwesomeIcon icon={faCartArrowDown} className="mr-2" />
                                        Create Order</Button>
                                </div>
                                <div className="float-right mt-4">
                                    <a className="btn btn-sm btn-outline-primary float-right" href="/box-configurations/">+ New Box Job Template</a>
                                </div>
                                <CreateOrderBatchModal
                                    isOpen={this.state.openBatchModal}
                                    toggle={this.toggleBatchModal}
                                    configurations={this.state.configurations}
                                    os={this.os}
                                />
                                <BoxConfigurationPagination
                                    page_size_key={"_boxConfigurationsPageSize"}
                                    url={process.env.REACT_APP_API_URL + '/api/v4/box_configurations'}
                                    data_attr={"box_configurations"}
                                    redirect_to={"my-box-configurations"}
                                    show_archived={false}
                                    os={this.os}
                                    onConfigurationsLoaded={this.handleConfigurationsLoaded}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}
export default MyBoxConfigurations;